const home = {
  heroAlt: "Fachleute prüfen Pläne bei einer Renovierung",
  galleryAlt: "Bau- und Renovierungsbranche",
  install: {
    iosSub: "Laden im",
    androidSub: "Jetzt bei",
    iosTitle: "Auf iPhone/iPad installieren",
    iosDesc: "Öffne diese Seite in Safari, tippe auf Teilen und dann auf „Zum Home-Bildschirm“.",
    androidTitle: "App installieren",
    androidDesc: "Öffne das Browsermenü und wähle „App installieren“ / „Zum Startbildschirm hinzufügen“.",
  },
  apps: {
    nuvliTitle: "NuvliPro Mobile-App",
    nuvliDesc: "Angebote, Rechnungen, Projekte, Ausgaben und Arbeitszeiterfassung auf deinem Handy.",
    nuvliInstall: "NuvliPro herunterladen",
    nuvliNote: "Direkte Installation (PWA) · funktioniert auf Android und iPhone, braucht keinen Speicherplatz.",
    workerTitle: "GPS-Zeiterfassung Mobile-App",
    workerDesc: "Für Mitarbeitende: Ein- und Ausstempeln mit GPS und Anmeldung mit Zugangscode.",
    workerInstall: "GPS-Zeiterfassung herunterladen",
    workerNote: "Für Mitarbeitende · nach der Installation die App öffnen und mit dem Zugangscode anmelden.",
    workerCta: "Mitarbeiter-App öffnen",
    qrTitle: "Zeiterfassung mit GPS",
    qrSubtitle: "Einfaches und sicheres Stempeln für dein Team",
    qrText: "Kostenlos auf unserer Website herunterladen",
    qrInstall: "Auf dem Handy installieren",
    qrAvailable: "Verfügbar für Android und iPhone",
  },
  login: {
    title: "Anmelden", email: "E-Mail", password: "Passwort", emailPh: "du@email.com", submit: "Anmelden",
    forgot: "Passwort vergessen?", register: "Kostenlos registrieren", welcome: "Willkommen", error: "Anmeldung fehlgeschlagen",
  },
  features: {
    badge: "Funktionen",
    title: "Alles, was du für dein Unternehmen brauchst",
    items: [
      { t: "Rechnungen", d: "Rechnungen mit automatischer Nummerierung, USt. und Einbehalt, Status und professionellem PDF-Download." },
      { t: "Angebote", d: "Angebote nach Kapiteln und beschreibenden Positionen; mit einem Klick in eine Rechnung umwandeln." },
      { t: "Ausgabenkontrolle", d: "Erfasse Material, Arbeitskosten und Lieferungen; kontrolliere die Ausgaben nach Projekt und Kategorie." },
      { t: "Teilzahlungen", d: "Erfasse Anzahlungen, behalte den offenen Saldo im Blick und versende Quittungen automatisch." },
      { t: "Quartalsberichte", d: "USt. und Einkommensteuer pro Quartal, bereit für deinen Steuerberater und exportierbar als PDF und Excel." },
      { t: "Kundenverwaltung", d: "Vollständige Kundenkartei, Dokumentenhistorie und Erkennung von Zahlungsverzug." },
    ],
  },
  pricing: {
    badge: "Tarife und Preise",
    title: "Wähle den Tarif, der am besten zu deinem Unternehmen passt",
    subtitle: "Kostenlos starten, ohne Enddatum. Upgrade, wann immer du mehr brauchst: keine Bindung, jederzeit kündbar.",
    freeCta: "Kostenloses Konto erstellen",
    labels: { gratuito: "Gratis-Tarif", trimestral: "Quartalstarif", anual: "Jahrestarif" },
    perMonth: "{{amount}}/Monat",
    approx: "≈ {{amount}}/Monat",
    periodo: { gratuito: "Ohne Enddatum", trimestral: "{{total}} alle 3 Monate", anual: "{{total}} pro Jahr" },
    nota: { gratuito: "Starten, ohne zu zahlen", trimestral: "Unbegrenzt, Zahlung alle 3 Monate", anual: "Eine Zahlung pro Jahr" },
    badges: { trimestral: "Am beliebtesten" },
    save: "Du sparst {{amount}}/Jahr",
    features: {
      gratuito: ["Bis zu 8 Kunden", "Bis zu 8 Angebote", "Rechnungen und Teilzahlungen für deine 8 Kunden", "Ausgaben und Quartale: die letzten 2 Quartale", "2 Bauprojekte", "Zeiterfassung mit unbegrenzt vielen Mitarbeitern"],
      trimestral: ["Unbegrenzt Kunden, Angebote und Projekte", "Vollständiger Verlauf von Ausgaben und Quartalen", "KI, VeriFactu und Bankabgleich", "Erinnerungen per E-Mail und WhatsApp", "Export für deinen Steuerberater"],
      anual: ["Alles aus dem Quartalstarif", "Individuelle Dokumente und Logo", "Geplante automatische Benachrichtigungen", "Bevorzugter Support"],
    },
    payCard: "Mit Karte zahlen",
    payNote: "Karte: automatische Verlängerung, jederzeit kündbar",
    footnote: "Preise zzgl. MwSt. · Zahlung per Karte · Sichere Zahlung über Stripe",
    approxNote: "Ungefährer Gegenwert in {{currency}} zum heutigen Wechselkurs. Der genaue Betrag wird auf der Zahlungsseite angezeigt.",
    payError: "Die Zahlung konnte nicht gestartet werden",
  },
  trust: {
    title: "Fachleute, die NuvliPro bereits vertrauen",
    subtitle: "Echte Bewertungen von Unternehmen aus der Bau- und Renovierungsbranche.",
    testimonials: [
      { cargo: "Geschäftsführer", empresa: "Constructora MendozaBuild S.A.", texto: "Wir haben über zehn Jahre mit Excel und Systemen gearbeitet, die nicht miteinander kommunizierten. Mit NuvliPro haben wir alle Informationen unserer 8 Projekte gebündelt und den Verwaltungsaufwand um 60 % reduziert. Die Rentabilitätsberichte pro Projekt sind jetzt präzise und ich entscheide mit echten Daten statt aus dem Bauch heraus." },
      { cargo: "Projektleiterin", empresa: "Grupo Constructor Rojas & Asociados", texto: "Wir sind von 3 auf 12 aktive Projekte gewachsen und unser manuelles System ist zusammengebrochen. Mit NuvliPro sind wir gewachsen, ohne das Verwaltungspersonal zu verdoppeln: lückenlose Nachverfolgung jedes Materials, Kontrolle der Subunternehmer in Echtzeit und 75 % weniger Abschlussdokumentation. Unsere Kunden erhalten Berichte, die Vertrauen schaffen." },
      { cargo: "Selbstständiger Inhaber", empresa: "18 Jahre in der Branche", texto: "Meine Aufträge wurden immer komplexer und weniger rentabel, und die Kosten liefen davon, ohne dass ich wusste, wo. Mit NuvliPro habe ich finanzielle Lecks gefunden, Lieferanten gebündelt und die Gemeinkosten um 22 % gesenkt, ohne an Qualität zu sparen. Heute erstelle ich detailliertere Angebote in kürzerer Zeit und gewinne mehr Projekte." },
    ],
    seals: [
      { t: "DSGVO-konform", d: "Geschützte Daten" },
      { t: "SSL-Verschlüsselung", d: "Sichere Verbindung" },
      { t: "Zahlungen mit Stripe", d: "Geschützte Zahlungen" },
      { t: "Support auf Spanisch", d: "Wann immer du ihn brauchst" },
    ],
  },
  demo: {
    badge: "Demo-Video",
    title: "Lerne NuvliPro in 2 Minuten kennen",
    subtitle: "Sieh dir an, wie du ein Angebot erstellst, es in eine Rechnung umwandelst und Zahlungen und Ausgaben im Blick behältst.",
    unsupported: "Dein Browser unterstützt die Videowiedergabe nicht.",
    soon: "Demo-Video folgt in Kürze",
  },
  faq: {
    badge: "Häufige Fragen",
    title: "Wir beantworten deine Fragen",
    items: [
      { q: "Brauche ich Buchhaltungskenntnisse, um NuvliPro zu nutzen?", a: "Nein. NuvliPro ist für Selbstständige und kleine Unternehmen gemacht: Du erstellst Angebote und Rechnungen, indem du klare Felder ausfüllst, und die App berechnet USt., Einbehalt und Summen automatisch." },
      { q: "Kann ich es kostenlos testen?", a: "Ja. Der Gratis-Tarif läuft nicht ab und braucht keine Karte: bis zu 8 Kunden, 8 Angebote, 8 Rechnungen und 1 aktives Bauprojekt. Wenn du mehr brauchst, wechselst du zu einem bezahlten Tarif." },
      { q: "Sind die Daten meiner Kunden sicher?", a: "Ja. Wir verschlüsseln die Verbindung (SSL), halten die DSGVO ein und Zahlungen werden sicher über Stripe abgewickelt. Wir geben deine Daten niemals weiter." },
      { q: "Kann ich meine Rechnungen und Angebote mit meinem Logo gestalten?", a: "Ja. In deinem persönlichen Bereich kannst du das Logo deines Unternehmens hochladen und das Dokumentdesign passend zu deiner Marke wählen." },
      { q: "Hilft NuvliPro bei der vierteljährlichen Steuerkontrolle?", a: "Ja. Es erstellt automatisch die Übersicht über Umsatzsteuer/Vorsteuer und Einkommensteuer pro Quartal, exportierbar als PDF und Excel für deinen Steuerberater." },
      { q: "Kann ich jederzeit kündigen?", a: "Natürlich. Es gibt keine Bindung: Du kannst deinen Tarif jederzeit in deinem Konto ändern oder kündigen." },
    ],
  },
  contact: {
    badge: "Kontakt",
    title: "Sollen wir reden?",
    subtitle: "Sag uns, was du brauchst, und wir melden uns so schnell wie möglich. Wir helfen dir, das Beste aus NuvliPro herauszuholen.",
    support: "Kundenservice",
    supportNote: "Support auf Spanisch · Antwort innerhalb von 24-48 Std.",
    name: "Name", namePh: "Dein Name", email: "E-Mail", emailPh: "du@email.com",
    message: "Nachricht", messagePh: "Wie können wir dir helfen?", send: "Nachricht senden",
    sent: "Nachricht gesendet! Wir melden uns bald.", error: "Die Nachricht konnte nicht gesendet werden",
  },
  cta: {
    title: "Dein ganzes Unternehmen an einem Ort",
    items: ["Kunden", "Angebote", "Rechnungen", "Teilzahlungen", "Ausgaben", "Quartal", "Zahlungsverzug", "WhatsApp"],
    button: "Kostenloses Konto erstellen",
  },
  footer: "Komplette Verwaltung für Profis aus Bau und Renovierung",
};
export default home;
